import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface ErrorState {
  error: Error | null;
  isLoading: boolean;
  setError: (error: Error) => void;
  clearError: () => void;
  setIsLoading: (isLoading: boolean) => void;
}

export const useErrorStore = create<ErrorState>()(
  devtools((set) => ({
    error: null,
    isLoading: true,
    setError: (error: Error) => set({ error, isLoading: false }),
    setIsLoading: (isLoading: boolean) => set({ isLoading }),
    clearError: () => set({ error: null }),
  })),
);
